import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
export const EvRange = ({ evRange  })=>{
    const { title , text  } = evRange;
    const rangeText = renderWithResolver(text);
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: sharedStyles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: sharedStyles.textContent,
                children: rangeText
            })
        ]
    });
};
